import CardManagement from './CardManagement.vue'
export default CardManagement



// WEBPACK FOOTER //
// ./src/pages/CardManagement/index.js